<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      pageTitle: 'Locations',
      breadcrumb: {
        name: 'Locations',
        route: { name: 'configuration-locations' }
      }
    }
  }
}
</script>

<style>

</style>
